import { render, staticRenderFns } from "./BoxWithIcons.vue?vue&type=template&id=16d2f778&scoped=true&"
import script from "./BoxWithIcons.vue?vue&type=script&lang=js&"
export * from "./BoxWithIcons.vue?vue&type=script&lang=js&"
import style0 from "./BoxWithIcons.vue?vue&type=style&index=0&id=16d2f778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d2f778",
  null
  
)

export default component.exports